module.exports = __webpack_public_path__ + "img/bank-rakyat-img.a0d3ae75.png";